import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

@ngCore.Component({
  imports: [ds.table.Component],
  selector: 'atn-admin-app-page-scenarios-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.scenarios.Collection} */
  public readonly scenariosEc = ngCore.inject(state.admin.scenarios.Collection)

  /** Canonical table input for scenarios in the current application. */
  public readonly scenariosTableConfig = {
    collection: this.scenariosEc,
    view: {
      search: true,
      showColumnSettings: false,
      title: 'Scenarios',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.scenarios.TypeParams>
}
